// Custom script to make filter options open by default on collection pages only
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on a collection page by looking at the URL or page type
  const isCollectionPage = 
    window.location.pathname.includes('/collections/') || 
    (typeof Shopify !== 'undefined' && Shopify.template === 'collection');
  
  // Only proceed if we're on a collection page
  if (isCollectionPage) {
    console.log('Collection page detected - initializing open filters script');
    
    // Wait for the page to fully load and for the Search & Discovery app to initialize
    setTimeout(function() {
      // Target the specific details elements used by the Search & Discovery app
      const filterDetails = document.querySelectorAll('details.facets__disclosure-vertical.js-filter');
      
      // Add the open attribute to each details element
      filterDetails.forEach(function(details) {
        details.setAttribute('open', '');
      });
      
      console.log('Open filters script executed - found ' + filterDetails.length + ' filters');
    }, 1000); // Slightly longer delay to ensure the app has fully loaded
  }
});
